import React, { useState, useEffect } from "react";
import axios from "axios";

interface ICountryTaxRateContext {
    recordCount: number
    countriesTaxRate: ICountryTaxRate[]
    isLoading: boolean
}

export interface ICountryTaxRate {
    countryCode: string
    countryName: string
    taxRateEcomB2C: number
    taxCodeEcomB2C: string
}

export let countryTaxRateContext = React.createContext<ICountryTaxRateContext>({} as ICountryTaxRateContext);

let { Provider } = countryTaxRateContext;

export let CountryTaxRateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let [isLoading, setLoading] = useState(true);
    let [countriesTaxRate, setCountriesTaxRate] = useState<ICountryTaxRate[]>([]);
    let [recordCount, setTotalRecords] = useState(0);

    useEffect(() => {
        getCountriesTaxRates();

    }, []);

    let getCountriesTaxRates = async () => {
        try {
            setLoading(true);

            let response = await axios.get('/api/Country/SearchDueCountries', { params: {} });
            setCountriesTaxRate(response.data.items);
            setTotalRecords(response.data.recordCount);

        } catch (error) { }
        finally {
            setLoading(false);
        }
    }

    return (
        <Provider value={{
            recordCount,
            countriesTaxRate,
            isLoading
        }}>
            {children}
        </Provider>
    );
};